import { render, staticRenderFns } from "./EBooleanBadge.vue?vue&type=template&id=625fb4a1&"
import script from "./EBooleanBadge.vue?vue&type=script&lang=js&"
export * from "./EBooleanBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('625fb4a1')) {
      api.createRecord('625fb4a1', component.options)
    } else {
      api.reload('625fb4a1', component.options)
    }
    module.hot.accept("./EBooleanBadge.vue?vue&type=template&id=625fb4a1&", function () {
      api.rerender('625fb4a1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/EBooleanBadge.vue"
export default component.exports